import { InputLabel, TextField, TextFieldProps } from '@mui/material';
import { useTranslate } from 'react-admin';

export const GrayTextFieldWithUpperLabel = (props: TextFieldProps) => {

  const translate = useTranslate();

  return (
    <>
      <InputLabel className="input-label">
        {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
      </InputLabel>
      <TextField
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        InputProps={{ ...props.InputProps, notched: false }}
      />
    </>
  );

};
